import { Box, Button, Dialog, DialogContent } from "@mui/material";
import React, { useState } from "react";
import Splitter from "../sign-in-splitter/Splitter";
import CloseIcon from "@mui/icons-material/Close";
import VerifyOtp from "../verify-otp/VerifyOtp";

const ValidateEmail = ({ open, onClose }) => {
  const [isLogin, setIsLogin] = useState(3);

  return (
    <>
      <Dialog
        maxWidth="xl"
        open={open}
        onClose={onClose}
        className="filter-dialog-product-search"
        aria-labelledby="category-filter-dialog"
        sx={{ maxHeight: "calc(100% - 12px) !important" }}
      >
        <DialogContent>
          <Box component="div" className="login-container">
            <Box component="div" className="splitter">
              <Box
                component="div"
                sx={{ maxHeight: "calc(100% - 0px)", height: "100%" }}
              >
                <Splitter isLogin={isLogin} setIsLogin={setIsLogin} />
              </Box>
            </Box>

            <Box component="div" className="login">
              <Box component="div" className="close">
                <Button
                  className="close-btn"
                  onClick={onClose}
                  sx={{ color: "#64748b", "&:hover": { color: "#0f172a", background: "#f1f5f9" } }}
                >
                  <CloseIcon />
                </Button>
              </Box>
              <VerifyOtp onClose={onClose} />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ValidateEmail;
